import { Injectable, Optional } from '@angular/core';
import { MUser } from '@argalis-apps/models';

export class ConfigServiceOption {
  options = null;
  eTypeUser: MUser.ETypeUser;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private _options = null;
  private _eTypeUser: MUser.ETypeUser = null;

  constructor(@Optional() config: ConfigServiceOption) {
    if (config) {
      this._options = config.options;
      this._options.api.identifier = this._options.production
        ? window.location.hostname.split('.')[0]
        : this._options.api.identifier;
      this._eTypeUser = config.eTypeUser;
    }
  }

  setOptions(value) {
    this._options = value;
  }

  getOptions() {
    return this._options;
  }

  getETypeUser() {
    return this._eTypeUser;
  }

  getSignatureBaseUrl(): string {
    return this._options.signatureBaseUrl || 'https://signature.argalis.fr';
  }
}
